import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** 表示するコンポーネントの種類 */
  type?:
    | 'detailLink'
    | 'deviceLink'
    | 'lendingUserLink'
    | 'language'
    | 'termsLink'
    | 'allPlanLink'
    | 'staticContentLink'
    | 'checkBoxLabel';
  /** クリック時のCallback */
  onClick: (e: React.MouseEvent) => void;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * リンクテキストコンポーネント
 */
export const LinkText: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  onClick,
  className,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = className || type;
  const _linkClsName = _clsName + 'Child';
  return (
    <Element {...props} className={_clsName} data-test={dataTest}>
      <a
        className={_linkClsName}
        onClick={onClick}
        data-test={`${dataTest}-link`}
      >
        {props.children}
      </a>
    </Element>
  );
};
LinkText.displayName = 'LinkText';
